<template>
<div class="bigdata-index">
    <!-- <div class="header">
        <span>{{pageArr[pageId].name}}</span>
        <div class="selecter">
            <el-select @change="goPage(pageId)" v-model="pageId" placeholder="请选择">
                <el-option v-for="item in pageArr" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div v-if="pageId != 4" class="download" @click="download">下载报表</div>
    </div> -->
    <div>
        <router-view></router-view>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageArr: [
                {
                    name: '销售区域日报',
                    id: 0,
                    path: 'sellareaday'
                },
                {
                    name: '销售区域周报',
                    id: 1,
                    path: 'sellareaweek'
                },
                {
                    name: '产销衔接日报',
                    id: 2,
                    path: 'productsale'
                },
                {
                    name: '销售计划完成情况',
                    id: 3,
                    path: 'sellplan'
                },
                {
                    name: '特种油配送看板',
                    id: 4,
                    path: 'specialboard'
                },
            ],
            pageId: 0
        }
    },
    methods: {
        goPage(pageIndex) {
            this.$router.push({
                'name': this.pageArr[pageIndex].path
            })
        },
        download() {
            if(this.pageId == 0) {
                this.downloadExel('daily?download=1');
            }
            else if(this.pageId == 1) {
                this.downloadExel('weekly?download=1');
            }   
            else if(this.pageId == 2) {
                this.downloadExel('sales_completion?download=1');
            }
            else if(this.pageId == 3) {
                this.downloadExel('production_marketing?download=1');
            }
        },
        downloadExel(page) {
            window.location.href = 'https://xarh.sprucesmart.com/api/v2/' + page;
        }
    }
}
</script>
<style scoped>
.bigdata-index > .header{
    position: relative;
    text-align: center;
    font-size: 24px;
    color: #000;
    font-weight: bold;
    height: 70px;
    line-height: 70px;
}
.selecter {
    position: absolute;
    right: 60px;
    top: 50%;
    transform: translate(0, -50%);
    
}
.hide {
    display: none;
}
.download {
    position: absolute;
    right: 290px;
    top: 30px;
    line-height: 20px;
    padding-left: 20px;
    background-image: url(../../../assets/imgs/icon_download.png);
    background-repeat: no-repeat;
    background-position: left center;
    font-size: 14px;
    color: #4A4A4A;
    
}
.download:hover {
    color: #00AE66;
    text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/pages/dataBoard/bigDataBoard/BigDataIndex.vue